/**
 * Deferred: a wrapper for Promise that exposes fulfill / reject / resolved
 */
export class Deferred {
    constructor(strict = false) {
        this.strict = strict;
        this._fulfill = nop;
        this._reject = nop;
        this._resolved = false;
        this._promise = new Promise((fulfill, reject) => {
            this._fulfill = (v) => {
                fulfill(v);
                this._resolved = true;
                this._fulfill = this._reject = nop;
            };
            this._reject = (e) => {
                reject(e);
                this._resolved = true;
                this._fulfill = this._reject = nop;
            };
        });
        this.then = this._promise.then.bind(this._promise);
        /**
         * complete the Deferred with a node-style callback
         * @param error
         * @param resolved
         */
        this.completeCallback = (error, resolved) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.fulfill(resolved);
            }
        };
    }
    get resolved() {
        return this._resolved;
    }
    /**
     * @param v the value
     */
    fulfill(v) {
        if (this.strict && this._resolved) {
            throw new Error('already resolved');
        }
        else {
            this._fulfill(v);
        }
    }
    reject(e) {
        if (this.strict && this._resolved) {
            throw new Error('already resolved');
        }
        else {
            this._reject(e);
        }
    }
}
function nop() { }
//# sourceMappingURL=deferred.js.map